import React from "react";
import { Helmet } from "react-helmet";
import { Box, Container } from "@mui/material";
import LabList from "../../components/labstructure/Manual/LabList";

const Labs1 = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <LabList />
        </Container>
      </Box>
    </React.Fragment>
  );
};

export default Labs1;